import angular from 'angular';

export class MeurhAdmissoesValetransporteFormmodalController implements angular.IController {

    static $inject = [];

    public valetransporte: any;
    public objadmissao: any;
    public action: string;
    public form: angular.IFormController;

    constructor() {/**/}

    $onInit(): void {
        if (!this.valorExiste(this.valetransporte.quantidade)) {
            this.valetransporte.quantidade = 2;
        }
        this.getTarifaconcess();
        this.validaTarifaDuplicada();
    }

    verificaCalculo(): void {
        if (this.valorExiste(this.valetransporte.tarifaconcessionariavt) && this.valorExiste(this.valetransporte.quantidade)) {
            this.calculaTotal();
        }
    }

    getTarifaconcess(): void {
        if (this.valorExiste(this.valetransporte.tarifaconcessionariavt)) {
            this.valetransporte.valor = this.valetransporte.tarifaconcessionariavt.valor;
        } else {
            this.valetransporte.valor = null;
            this.valetransporte.totaldiario = null;
        }
        if (this.valorExiste(this.valetransporte.quantidade) && this.valetransporte.quantidade > 0) {
            this.calculaTotal();
        }
        this.validaTarifaDuplicada();
    }

    calculaTotal(): void {
        this.valetransporte.totaldiario = this.valetransporte.valor * this.valetransporte.quantidade;
    }

    validaTarifaDuplicada(): void {
        if (!this.form || !this.form.tarifaconcessionariavt) {
            return;
        }

        const tarifaSelecionada = this.valetransporte?.tarifaconcessionariavt?.tarifaconcessionariavt;
        if (!tarifaSelecionada) {
            this.form.tarifaconcessionariavt.$setValidity('tarifaDuplicada', true);
            return;
        }

        const vtDuplicado = Array.isArray(this.objadmissao?.vts) && this.objadmissao.vts.some((vt: any) => {
            const tarifaExistente = vt?.tarifaconcessionariavt?.tarifaconcessionariavt;
            if (!tarifaExistente) {
                return false;
            }

            const mesmoRegistro = this.valorExiste(this.valetransporte?.counter) && vt.counter === this.valetransporte.counter;
            return !mesmoRegistro && tarifaExistente === tarifaSelecionada;
        });

        this.form.tarifaconcessionariavt.$setValidity('tarifaDuplicada', !vtDuplicado);
    }

    valorExiste(valor: any): boolean {
        return valor !== '' && valor !== undefined && valor !== null ? true : false;
    }
}
